import {
  FlexBox,
  LoadingButton,
  TabButton,
} from '@airship-platform/jam-web/components';
import Divider from '@mui/material/Divider';
import { Link as RouterLink } from 'react-router';
import { AppointmentProposalOption } from '../../../data-access/appointmentProposalOptions';
import { AppointmentProposal } from '../../../data-access/appointmentProposals';
import { CustomerContactsButton } from '../../../patterns';
import ROUTE_PATHS from '../../../routes/paths';
import ProposalNavigationButton from '../../proposal-navigation/Buttons/ProposalNavigationButton';
import { ManageOptionsButton } from '../../proposal-options';
import EditPresentationButton from './EditPresentationButton';
import ProposalScoreIndicator from './ProposalScoreIndicator';
import SyncProposalOptionsButton from './SyncProposalOptionsButton';

interface OptionsBuilderHeaderProps {
  isLoading: boolean;
  customerName: string;
  isViewPresentationButtonDisabled?: boolean;
  currentProposal: AppointmentProposal;
  options: (AppointmentProposalOption & {
    isSelected: boolean;
    itemCount: number;
  })[];
}

const OptionsBuilderHeader: React.FC<OptionsBuilderHeaderProps> = ({
  isLoading,
  customerName,
  isViewPresentationButtonDisabled,
  currentProposal,
  options,
}) => (
  <FlexBox
    flexDirection={'column'}
    gap={3}
    position={['static', 'sticky']}
    top={45}
    width="100%"
    zIndex={100}
    bgcolor="background.paper"
    py={3}
  >
    <FlexBox
      flexDirection={['column-reverse', 'column-reverse', 'row']}
      alignItems={'center'}
      justifyContent={'space-between'}
      gap={2}
    >
      <FlexBox width={'100%'} flexWrap={'wrap'} gap={2}>
        <ProposalNavigationButton />
        <EditPresentationButton />
        <CustomerContactsButton
          customerName={customerName}
          to={ROUTE_PATHS.APPOINTMENT_PATH({
            appointmentId: currentProposal.appointmentId,
            appointmentProposalId: currentProposal.appointmentProposalId,
            path: 'contacts',
          })}
        />
      </FlexBox>

      <FlexBox
        flexDirection={['row', 'row', 'row-reverse']}
        alignItems={'center'}
        width={['100%', '100%', 'auto']}
        gap={2}
      >
        <LoadingButton
          loading={isLoading}
          component={RouterLink}
          size="medium"
          disabled={isViewPresentationButtonDisabled}
          to={ROUTE_PATHS.APPOINTMENT_PATH({
            appointmentId: currentProposal.appointmentId,
            appointmentProposalId: currentProposal.appointmentProposalId,
            path: 'present',
          })}
          sx={{ flex: [1, 1, 'none'] }}
        >
          View presentation
        </LoadingButton>
        <ProposalScoreIndicator />
      </FlexBox>
    </FlexBox>
    <SyncProposalOptionsButton />
    <Divider />
    <FlexBox
      flexDirection={['column', 'row']}
      alignItems="flex-start"
      flex={1}
      width={'100%'}
      gap={2}
    >
      <FlexBox flexWrap={'wrap'} gap={1} flex={1} overflow={'hidden'}>
        {options.map((option) => (
          <TabButton
            component={RouterLink}
            key={option.appointmentProposalOptionId}
            label={`${option.name} (${option.itemCount})`}
            isSelected={option.isSelected}
            sx={{ minWidth: 50 }}
            to={ROUTE_PATHS.PROPOSAL_OPTIONS_PATH({
              appointmentId: currentProposal.appointmentId,
              appointmentProposalId: currentProposal.appointmentProposalId,
              appointmentProposalOptionId: option.appointmentProposalOptionId,
            })}
          />
        ))}
      </FlexBox>
      <ManageOptionsButton />
    </FlexBox>
  </FlexBox>
);

export default OptionsBuilderHeader;
